export class Fuzz {
    constructor(ctx) {
        this.ctx = ctx;
        this.input = ctx.createGain();
        this.output = ctx.createGain();
        
        // Nodes
        this.preGain = ctx.createGain(); // Drive
        this.shaper = ctx.createWaveShaper();
        this.tone = ctx.createBiquadFilter();
        this.wet = ctx.createGain();
        this.dry = ctx.createGain();

        // Routing
        // Input -> Dry -> Output
        this.input.connect(this.dry);
        this.dry.connect(this.output);

        // Input -> PreGain -> Shaper -> Tone -> Wet -> Output
        this.input.connect(this.preGain);
        this.preGain.connect(this.shaper);
        this.shaper.connect(this.tone);
        this.tone.connect(this.wet);
        this.wet.connect(this.output);

        // Defaults
        this.tone.type = 'lowpass';
        this.tone.frequency.value = 3000;
        this.shaper.oversample = '4x';
        
        // Static Fuzz Curve (Hard Clipping)
        this.generateFuzzCurve();
        
        // Initial Params
        this.preGain.gain.value = 1.0;
        this.dry.gain.value = 0.0;
        this.wet.gain.value = 1.0;
    }

    setup() {
        return Promise.resolve();
    }

    getInput() { return this.input; }
    getOutput() { return this.output; }

    generateFuzzCurve() {
        // High gain sigmoid-ish curve for fuzz character
        const samples = 44100;
        const curve = new Float32Array(samples);
        for (let i = 0; i < samples; i++) {
            const x = (i * 2) / samples - 1;
            
            // "Gate" effect: silence low levels for that "ripped speaker" sound
            if (Math.abs(x) < 0.05) {
                curve[i] = 0;
            } else {
                // Hard clip with slight smoothing
                // Math.tanh is good, but let's go flatter
                const gain = 10;
                let y = x * gain;
                if (y > 1) y = 1;
                if (y < -1) y = -1;
                curve[i] = y;
            }
        }
        this.shaper.curve = curve;
    }

    setFuzz(amount) {
        // amount 0 - 100
        // Drive the preGain into the shaper
        // Range 1x to 100x
        const gain = 1 + amount; 
        this.preGain.gain.setTargetAtTime(gain, this.ctx.currentTime, 0.01);
    }

    setTone(value) {
        // value 0 - 1
        // Map to frequency 200Hz - 10000Hz (Logarithmic feel)
        const min = 200;
        const max = 10000;
        const freq = min * Math.pow(max / min, value);
        this.tone.frequency.setTargetAtTime(freq, this.ctx.currentTime, 0.05);
    }

    setMix(value) {
        this.wet.gain.setTargetAtTime(value, this.ctx.currentTime, 0.01);
        this.dry.gain.setTargetAtTime(1 - value, this.ctx.currentTime, 0.01);
    }
}
